
export const url =process.env.NODE_ENV === "development" ? "https://dalmaf.com/dalmaf" : "/dalmaf";

export const entrepreneur_service_url = process.env.NODE_ENV === "development" ? "https://dalmaf.com/entrepreneur-service/" : "https://dalmaf.com/entrepreneur-service/";
export const payment_service_url = process.env.NODE_ENV === "development" ? "https://dalmaf.com/payment-service/" : "https://dalmaf.com/payment-service/";
export const lead_service_url = process.env.NODE_ENV === "development" ? "https://dalmaf.com/lead-service/" : "https://dalmaf.com/lead-service/";


export const entrepreneur_ui_url = process.env.NODE_ENV === "development" ? "http://localhost:3001/business-portal" : "https://dalmaf.com/business-portal";

export const proconnect_ui_url = process.env.NODE_ENV === "development" ? "http://localhost:3001/pro-connect" : "https://dalmaf.com/pro-connect";

export const traders_shield_ui_url = process.env.NODE_ENV === "development" ? "http://localhost:3001/traders-shield-portal" : "https://dalmaf.com/traders-shield-portal";
export const project_portal_ui_url = process.env.NODE_ENV === "development" ? "http://localhost:3001/dalmaf-portal" : "https://dalmaf.com/dalmaf-portal";

export const dalmaf_url = process.env.NODE_ENV === "development" ? "https://dalmaf.com" : "https://dalmaf.com";


export const protal_dalmaf_url = process.env.NODE_ENV === "development" ? "http://localhost:8015/dpl-project" : "https://dalmaf.com/dpl-project";




